import {
	fetch,
    fetchForCVO,
	sconfig,
} from '@/config/fetch'
const product = require('@/service/mock/product')
if (sconfig.all||(!sconfig.all&&sconfig.order)) {
	
}
else{
	var getVIPMeetingRooms = (token,vipno,params) => fetchForCVO('GET','LifeVIP_001',token,vipno,params)
	var getVIPMeetingRoom = (token,vipno,params) => fetchForCVO('GET','LifeVIP_001',token,vipno,params)
	var getVIPMeetingDurations = (token,vipno,params) => fetchForCVO('GET','LifeVIP_002',token,vipno,params)
	var postVIPReservationRooms = (token,vipno,params) => fetchForCVO('POST','LifeVIP_003',token,vipno,params)
	var getVIPReservationOrders = (token,vipno,params) => fetchForCVO('GET','LifeVIP_006',token,vipno,params)
	var getVIPReservationCalendar = (token,vipno,params) => fetchForCVO('GET','LifeVIP_009',token,vipno,params)
	var getVIPReservationCart = (token,vipno,params) => fetchForCVO('GET','LifeVIP_004',token,vipno,params)
	var getVIPReservationDetail = (token,vipno,params) => fetchForCVO('GET','LifeVIP_007',token,vipno,params)
	var postVIPReservationAdditional = (token,vipno,params) => fetchForCVO('POST','LifeVIP_005',token,vipno,params)
	var postVIPDeterminePaymentuser = (token,vipno,params) => fetchForCVO('POST','LifeVIP_018',token,vipno,params)// 代缴用户
	var postVIPCancelReservation = (token,vipno,params) => fetchForCVO('GET','LifeVIP_008',token,vipno,params)
	var getVIPStores = (token,vipno,params) => fetchForCVO('GET','LifeVIP_010',token,vipno,params)
	var getVIPUserRank = (token,vipno) => fetchForCVO('GET','LifeVIP_011', token,vipno)
	var getVIPMeetingOrderTime = (token,vipno,ParentCode,Code) => fetchForCVO('GET','LifeVIP_012',token,vipno,{ParentCode,Code})
	var getVIPMeetingPoint = (token,vipno) => fetchForCVO('GET','LifeVIP_019',token,vipno)
	var postVIPAloneCancel = (token,vipno,params) => fetchForCVO('POST','LifeVIP_020',token,vipno,params)
}

export {
	getVIPMeetingRooms,
	getVIPMeetingRoom,
	getVIPMeetingDurations,
	postVIPReservationRooms,
	getVIPReservationOrders,
	getVIPReservationCalendar,
	getVIPReservationCart,
	getVIPReservationDetail,
	postVIPReservationAdditional,
	postVIPDeterminePaymentuser,
	postVIPCancelReservation,
	getVIPStores,
	getVIPUserRank,
	getVIPMeetingOrderTime,
	getVIPMeetingPoint,
	postVIPAloneCancel,
}